import moment from "moment";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { languageService } from "../../../../Language/language.service";
import { dateSort } from "../../../../utils/sortingMethods";

export const hosStatusViewSchema = [
  {
    Header: languageService("Name"),
    accessor: "name",
  },
  {
    Header: languageService("Title"),
    accessor: "title",
  },
  {
    Header: languageService("Employee ID"),
    accessor: "email",
  },

  {
    Header: languageService("Last Time Recorded"),
    accessor: "lastTimeRec",
    Cell: (_props) => {
      const { value, original } = _props;
      let toRet = "N/A";
      if (original && original.lastTimeRec) {
        toRet = dataFormatters.dateTimeFormatterWithTimezone(original.lastTimeRec.endDate, original.lastTimeRec.timezone, true);
      }
      return toRet;
    },
    sortMethod: (a, b) => {
      const aTime = a && a.endDate ? new Date(a.endDate).getTime() : -Infinity;
      const bTime = b && b.endDate ? new Date(b.endDate).getTime() : -Infinity;
      return bTime - aTime;
    },
    minWidth: 150,
  },
  {
    Header: languageService("Off Duty Status"),
    accessor: "offDutyStatus",
    Cell: (_props) => {
      const { value, original } = _props;
      let toRet = "N/A";
      if (original && original.offDutyStatus) {
        let status = original.offDutyStatus.activityType ? original.offDutyStatus.activityType.value : "";
        toRet = `${status} untill ${dataFormatters.dateFormatter(
          moment(original.offDutyStatus.endDate).tz(original.offDutyStatus.timezone).subtract(1, "day"),
        )}`;
      }
      return toRet;
    },
    minWidth: 150,
  },
  {
    Header: languageService("Fully Rested At"),
    accessor: "fullyRestedAt",
    Cell: (_props) => {
      const { value, original } = _props;
      let toRet = "N/A";
      if (original && original.lastTimeRec) {
        toRet = dataFormatters.dateTimeFormatterWithTimezone(original.fullyRestedAt, original.lastTimeRec.timezone, true);
      }
      return toRet;
    },
    sortMethod: (a, b) => {
      const aTime = a && a ? new Date(a).getTime() : -Infinity;
      const bTime = b && b ? new Date(b).getTime() : -Infinity;
      return bTime - aTime;
    },
    minWidth: 150,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HOSStatusView/schema/hostatusschema.js